module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/raiten-tokuten-e6b0c93329aa6a746b43403c04fd22eb.png";